module.exports = __webpack_public_path__ + "img/081.0b2ebbe3.png";